import { CommonAdapter, getAdapter } from 'owa-addins-apis';
import { getUserTypeString } from 'owa-addins-apis';
import { getScenarioFromHostItemIndex, IAddinCommand } from 'owa-addins-store';
import {
    getClientApp,
    getClientDeploymentRing,
    getClientId,
    getClientVersion,
} from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export interface OsfControl {
    addinCommand: IAddinCommand;
    controlId: string;
    isDialog?: boolean;
    sourceLocation?: string;
}

export function createDictionaryFromOsfControl(
    hostItemIndex: string,
    osfControl: OsfControl,
    extensionContainer: HTMLDivElement
) {
    const { addinCommand, controlId, isDialog } = osfControl;
    const settings = !!addinCommand.extension.Settings
        ? JSON.parse(addinCommand.extension.Settings)
        : {};
    const hostCustomMessage = createHostCustomMessage(addinCommand, hostItemIndex);

    return {
        div: extensionContainer,
        id: controlId,
        marketplaceID: !isDialog ? addinCommand.extension.Id : controlId,
        marketplaceVersion: addinCommand.extension.Version,
        settings: settings,
        store: '',
        storeType: OSF.StoreType.Exchange,
        // disabling the hostCustomMessage when OTelJS is enabled, since these data columns are logged natively
        hostCustomMessage: isFeatureEnabled('addin-oteljs') ? undefined : hostCustomMessage,
        isDialog: isDialog,
        isVirtualOsfControl: false,
    };
}

/*
    hostCustomMessage:
    {
        userType: office365|outlookCom|enterprise
        userId: [clientId] ("7969A331813045F8B87BD957D6149945")
        extensionType: Default|PrivateCatalog|MarketplacePrivateCatalog|Marketplace|Private|Preinstalled
        module: Mail|Calendar
        scenario: Read|Compose
        deployment: DSDF|DWW|GALLATIN|SDF|SDFV2|SIP|WW
        clientVersion: [scriptVersion] ("20180126009")
        isPinned: true|false
        react: true
    }
*/
function createHostCustomMessage(addinCommand: IAddinCommand, hostItemIndex: string): string {
    const adapter = getAdapter(hostItemIndex) as CommonAdapter;

    return JSON.stringify({
        userType: getUserTypeString(),
        userId: getClientId(),
        extensionType: addinCommand.extension.TypeString,
        module: getClientApp(),
        deployment: getClientDeploymentRing(),
        scenario: getScenarioFromHostItemIndex(hostItemIndex),
        clientVersion: getClientVersion(),
        isPinned: adapter.isAddinPinned(addinCommand.extension.Id),
        react: true,
        disableLogging: getClientDeploymentRing() === 'ITAR',
    });
}
